<script setup>
import { toRefs } from 'vue';
import AppCodeBlock from '@/components/general/CodeBlock.vue';

const props = defineProps({
  header: {
    type: String,
    required: true,
  },
  headerIcon: {
    type: String,
    required: false,
  },
  subheader: {
    type: String,
  },
  code: {
    type: [String, Object],
  },
});
const { header, code, headerIcon } = toRefs(props);
</script>

<template>
  <div class="mb-6 flex w-full flex-col">
    <p
      v-if="header"
      class="mb-2 flex items-center gap-1 text-sm font-medium text-gray-900 dark:text-white"
    >
      <img
        v-if="headerIcon"
        :src="headerIcon"
        alt="Header Icon"
        class="h-6 w-6"
      />
      {{ header }}
    </p>
    <p v-if="subheader" class="mb-2 text-sm text-gray-500">
      {{ subheader }}
    </p>
    <app-code-block :code="code" />
  </div>
</template>
